import { render, staticRenderFns } from "./wordRecognise.vue?vue&type=template&id=3c079aa9&scoped=true"
import script from "./wordRecognise.vue?vue&type=script&lang=js"
export * from "./wordRecognise.vue?vue&type=script&lang=js"
import style0 from "./wordRecognise.vue?vue&type=style&index=0&id=3c079aa9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c079aa9",
  null
  
)

export default component.exports